import { ESolarPlantViewType } from "../enums/solar-plant-view-type";

export const getSolarPlantViewType = (
  startDate: Date,
  endDate: Date
): ESolarPlantViewType => {
  const diffInMs = endDate.getTime() - startDate.getTime();
  const diffInHours = diffInMs / (1000 * 60 * 60);
  const diffInDays = diffInHours / 24;

  if (diffInHours <= 1) {
    return ESolarPlantViewType.MINUTELY;
  } else if (diffInHours > 1 && diffInDays <= 2) {
    return ESolarPlantViewType.HOURLY;
  } else if (diffInDays > 2 && diffInDays <= 30) {
    return ESolarPlantViewType.DAILY;
  } else if (diffInDays > 30 && diffInDays <= 90) {
    return ESolarPlantViewType.WEEKLY;
  } else if (diffInDays > 90 && diffInDays <= 1095) {
    return ESolarPlantViewType.MONTHLY;
  } else {
    return ESolarPlantViewType.YEARLY;
  }
};
